import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';
import moment from 'moment'

import Vue from 'vue'

const getDefaultStateForStockCards = () => {
  return {
    stockcards: [],
    available_qty:0,
    inventory:[],
    inventory_details:[],
    is_confirmation_required:false,
    confirmation_messages:[],
    is_stockcard_created:0,
    lots:[],
    data:{},
    filter_inventory:{
      keyword:""
    },
    filter:{
        keyword:"",
        date_from:null,
        date_to:null,
        direction:'IN'
    }
  }
}

// state
const state = getDefaultStateForStockCards()

const getters = {

}

// mutations
const mutations = {
    SET_INVENTORY_DETAILS(state, data) {
      if(data)
      {
          data.forEach(function(element) {
            element.lot_reference = (element.lot_reference != null && element.lot_reference != '') ? element.lot_reference : '-'
            element.expiry_date = (element.expiry_date != null && element.expiry_date != '') ? (moment(element.expiry_date).format('DD/MM/YYYY')) : '-'
            element.time_created = (element.time_created != null && element.time_created != '') ? (moment(element.time_created).format('DD/MM/YYYY, h:mm a')) : '-'
          });

        state.inventory_details = data
      }
    },
    RESET_STATE_FOR_STOCKCARDS (state) {
      Object.assign(state, getDefaultStateForStockCards())
    },
    SET_SHOW_CONFIRMATION(state, data)
    {
      if(data)
      {
          state.is_confirmation_required = data.is_confirmation_required
          state.confirmation_messages = data.messages
      }
    },
    SET_IS_CREATED(state, data)
    {
      state.is_stockcard_created = data
    },
    SET_FILTER(state, data)
    {
      state.filter = data
    },
    SET_FILTER_INVENTORY(state, data)
    {
      state.filter_inventory = data
    },
    SET_LOTS(state, data)
    {
      state.lots = data
    },
    FETCH_ALL_INVENTORY(state, data)
    {
      if(data)
      {

        data.forEach(function(element) {
            element.expiry_from_date = (element.expiry_from_date != null && element.expiry_from_date != '') ? (moment(element.expiry_from_date).format('DD/MM/YYYY')) : '-'
            element.expiry_to_date = (element.expiry_to_date != null && element.expiry_to_date != '') ? (moment(element.expiry_to_date).format('DD/MM/YYYY')) : '-'

            if(element.day_diff != null && element.day_diff != '' && element.day_diff > 0)
            {
              element.date_range = element.expiry_from_date  + ' - ' + element.expiry_to_date;
            }
            else
            {
              element.date_range = '-'
            }

        });
        state.inventory = data

      }
    },
    SET_PRODUCT_AVAILABLE_QTY(state, data)
    {
      state.available_qty = data
    },
    FETCH_ALL(state, data )
    {
      if(data)
      {

        data.forEach(function(element) {
            element.time_created = (element.time_created != null && element.time_created != '') ? (moment(element.time_created).format('DD/MM/YYYY, h:mm a')) : '-'
        });
        state.stockcards = data

      }

    },
    FETCH(state, data) {
      if (data) {
          state.data = data
      }
  },
}

// actions
const actions = {
  retrieveLots({ commit }, data) {
    return axios.post(apiRoutes['RETRIEVE_LOTS'], data, authHeader())
        .then(response => {
            if (response.data.code == 1) {
                commit('SET_LOTS', response.data.data)
            } else {
                commit('SET_LOTS', {})
            }
        })
        .catch(error => {
            if (error.response) {
                console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
    },
  getProductAvailableQty({ commit }, data) {
    return axios.post(apiRoutes['GET_PRODUCT_AVAILABLE_QTY'], data, authHeader())
        .then(response => {
            if (response.data.code == 1) {
                commit('SET_PRODUCT_AVAILABLE_QTY', response.data.data)
            } else {
                commit('SET_PRODUCT_AVAILABLE_QTY', 0)
            }
        })
        .catch(error => {
            if (error.response) {
                console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
    },
    fetch({ commit }, data) {
      return axios.post(apiRoutes['STOCKCARDS_RETRIEVE'], data, authHeader())
          .then(response => {
              if (response.data.code == 1) {
                  commit('FETCH', response.data.data)
              } else {
                  commit('FETCH', {})
              }
          })
          .catch(error => {
              if (error.response) {
                  console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
      },
  quickSearch({ commit }, data) {
        return axios.post(apiRoutes['STOCKCARDS_QUICK_SEARCH'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('FETCH_ALL', response.data.data)
                commit('SET_FILTER', data)
              } 
              else 
              {
                commit('FETCH_ALL', [])
                commit('SET_FILTER', data)
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
  },
  getInventoryDetails({ commit }, data) {
    return axios.post(apiRoutes['GET_INVENTORY_DETAILS'], data, authHeader())
        .then(response => {
          if(response.data.code == 1)
          {
            commit('SET_INVENTORY_DETAILS', response.data.data)
          } 
          else 
          {
            commit('SET_INVENTORY_DETAILS', [])
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response)
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem Querying Data!", error);
          }
      });
},
  quickSearchInventory({ commit }, data) {
    return axios.post(apiRoutes['INVENTORY_QUICK_SEARCH'], data, authHeader())
        .then(response => {
          if(response.data.code == 1)
          {
            commit('FETCH_ALL_INVENTORY', response.data.data)
            commit('SET_FILTER_INVENTORY', data)
          } 
          else 
          {
            commit('FETCH_ALL_INVENTORY', [])
            commit('SET_FILTER_INVENTORY', data)
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response)
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem Querying Data!", error);
          }
      });
},
    resetState({ commit, dispatch }, payload) {
      commit("RESET_STATE_FOR_STOCKCARDS")
    },
    async create({ commit, dispatch }, data) {
        await axios
            .post(apiRoutes['STOCKCARD_CREATE_FROM_LIST'], data, authHeader())
            .then(function(response) {
                if (response.data.code == 1) 
                {
                    let doc_number = response.data.data.code
                    commit('SET_IS_CREATED', 1);
                    Vue.notify({text: 'GRN (' + doc_number + ')' + " has been created!", type: 'success', group: 'notify', max: 5, duration: 5000, speed: 300})
                    commit("SET_SHOW_CONFIRMATION", {is_confirmation_required:0, messages:[]})
                } 
                else 
                {
                    let message = response.data.msg

                    if(message == 'required_confirmation')
                    {
                        commit('SET_IS_CREATED', 0);
                        commit("SET_SHOW_CONFIRMATION", {is_confirmation_required:1, messages:response.data.data.errors})
                    }
                    else
                    {
                        commit('SET_IS_CREATED', 0);
                        commit("SET_SHOW_CONFIRMATION", {is_confirmation_required:0, messages:[]})
                        let errors = response.data.data.errors
                        if (Array.isArray(errors)) {
                            let msg = errors.join("\n")
                            Vue.notify({
                                group: 'notify',
                                type: 'error',
                                text: msg,
                                max: 5,
                                duration: 5000,
                                speed: 300
                            })
                        }
                    }


                }

            })
            .catch((error) => {
                // alert(error)
                commit('SET_IS_CREATED', 0);

                if (error.response) {
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.message,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                } else {
                    //console.log("Problem submitting New Post", error);
                    alert("Application Error")
                }
            });
    },

}

export {
    state,
    getters,
    actions,
    mutations
}
